export enum actionTypes {
  NIVELES_IDIOMA_FETCH = 'NIVELES_IDIOMA_FETCH',
  NIVELES_IDIOMA_SUCCESS = 'NIVELES_IDIOMA_SUCCESS',
  NIVELES_IDIOMA_ERROR = 'NIVELES_IDIOMA_ERROR',
  NIVELES_IDIOMA_RESET = 'NIVELES_IDIOMA_RESET',
}

export enum NivelesIdiomaStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface NivelIdioma {
  id: number
  nombre: string
}

export interface NivelesIdiomaState {
  status: NivelesIdiomaStatus
  nivelesIdioma: Array<NivelIdioma>
}

export interface NivelesIdiomaFetch {
  type: typeof actionTypes.NIVELES_IDIOMA_FETCH
  payload: null
}

export interface NivelesIdiomaSuccess {
  type: typeof actionTypes.NIVELES_IDIOMA_SUCCESS
  payload: { nivelesIdioma }
}

export interface NivelesIdiomaError {
  type: typeof actionTypes.NIVELES_IDIOMA_ERROR
  payload: null
}

export interface NivelesIdiomaReset {
  type: typeof actionTypes.NIVELES_IDIOMA_RESET
  payload: null
}

export type NivelesIdiomaActions =
  | NivelesIdiomaFetch
  | NivelesIdiomaSuccess
  | NivelesIdiomaError
  | NivelesIdiomaReset

export const initialState: NivelesIdiomaState = {
  status: NivelesIdiomaStatus.Idle,
  nivelesIdioma: [],
}
